// Компонент кнопки для меню и тогглера в демо-форме

const template = /* html */`
    <button
        :class="[
            'nx-demo-form-menu-button',
            active ? 'nx-demo-form-menu-button--active' : '',
            transparent
                ? 'nx-demo-form-menu-button--transparent'
                : 'nx-demo-form-menu-button--colored',
            hoverable ? 'nx-demo-form-menu-button--hoverable' : '',
            rounded ? 'nx-demo-form-menu-button--rounded' : '',
        ]"
    >
        <slot></slot>
    </button>
`;

export default {
    name: "DemoFormButton",
    template,
    props: {
        active: {
            type: Boolean,
            default: false,
        },
        transparent: {
            type: Boolean,
            default: false,
        },
        hoverable: {
            type: Boolean,
            default: true,
        },
        rounded: {
            type: Boolean,
            default: true,
        },
    },
};
